import React, { useEffect, useState } from "react";
import { Input, Radio, Divider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchHotelOffers } from "../../../redux/flight/hotelOffersSlice";
import { setModal2Open } from "../../../redux/hotel/modalSlice";
import { FaTimes } from "react-icons/fa";

const HotelOffers = ({
  appliedCheckLogin,
  setAppliedCheckLogin,
  applyDiscount,
  applyDiscountShow,
  setApplyDiscountShow,
  isCongratulations,
  setIsCongratulations,
  isValidCoupon,
  setValidCoupon,
}) => {
  const dispatch = useDispatch();
  const { offers, loading, error } = useSelector((state) => state.hotelOffers);

  useEffect(() => {
    dispatch(fetchHotelOffers());
  }, [dispatch]);
  //console.log("isValidCoupon",isValidCoupon)

  const [selectedCode, setSelectedCode] = useState("");
  const [appliedCode, setAppliedCode] = useState("");
  const [isDisabled, setIsDisabled] = useState(null);

  const handleInputChange = (e) => {
    setSelectedCode(e.target.value);
  };

  const handleRemoveCode = () => {
    setSelectedCode("");
    setAppliedCheckLogin(null);
    setApplyDiscountShow(false);
    setIsDisabled(false);
    setIsCongratulations(false);
    setValidCoupon(null);
  };

  let getTokenId = JSON.parse(localStorage.getItem("tokenId"));

  useEffect(() => {
    if (!appliedCheckLogin) return;
    if (appliedCheckLogin?.is_login === 1 && !getTokenId) {
      dispatch(setModal2Open(true));
    } else if (appliedCheckLogin?.is_login === 1 && getTokenId) {
      applyDiscount();
    } else if (!appliedCheckLogin?.is_login) {
      applyDiscount();
    }
  }, [appliedCheckLogin]);

  const handleRadioChange = (code, offer) => {
    setSelectedCode(code);
    setAppliedCheckLogin(offer);
    setIsDisabled(true);
    setApplyDiscountShow(false);
    setIsCongratulations(false);
    setValidCoupon(null);
  };


  return (
    <>
      <div className="card d-none d-md-block">
        <div className="card-header py-2">
          <h3>Apply Discount</h3>
          <p className="fw-bold">
            <small>Have a discount/ promo code to redeem</small>
          </p>
        </div>

        <div className="card-body py-2">
          <div className="d-flex gap-10 mt-1 mb-4">
            <Input
              type="text"
              value={selectedCode}
              onChange={handleInputChange}
              placeholder="Promo Code"
              className="form-control rounded"
              style={{ height: "40px", padding: "10px", outline: "none" }}
              // suffix={
              //   selectedCode && <FaTimes onClick={handleRemoveCode} />
              // }
              suffix={
                <span style={{ visibility: selectedCode ? "visible" : "hidden" }}>
                  <FaTimes onClick={handleRemoveCode} style={{ cursor: "pointer" }} />
                </span>
              }
            />
            {applyDiscountShow && (
              <a
                className="btn btn-primary menu-block rounded text-center"
                onClick={handleRemoveCode}
              >
                Remove
              </a>
            )}
          </div>
          {isCongratulations && (
            <p className="text_grn mb-2">
              Congratulations coupon code has been applied successfull{" "}
              {appliedCheckLogin?.description}
            </p>
          )}
          {isValidCoupon !== null && (
            <p className="text_red mb-2" style={{ color: "red" }}>
              {isValidCoupon}
            </p>
          )}
          <div>
            {offers.map((offer, index) => (
              <div key={index}>
                <label className="d-flex align-items-center gap-10">
                  <span>
                    <Radio
                      id={offer?.code}
                      name="offerradio"
                      checked={selectedCode === offer?.code}
                      onChange={() => handleRadioChange(offer?.code, offer)}
                    />
                  </span>
                  <div>
                    <p>
                      <b>{offer.code}</b>
                    </p>
                    <p className="lh-14">
                      <small className="fw-bold">{offer?.description}</small>
                    </p>
                  </div>
                </label>
                {index < offers?.length - 1 && <Divider className="my-3" />}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default HotelOffers;
